import type { ResultEnvelope } from "@cd/core";
import { Badge, Tip } from "../../components/ui/primitives";
import { describePageFilter, type PageFilter } from "../../lib/pageFilters";

/**
 * Which of the page's chips a result took and which it skipped, each said in its header so a click
 * that changed it (or didn't) is never a surprise. `sent` is the chips the query was sent.
 */
export function PageFilterBadges({ result, sent, pageFilters }: { result: ResultEnvelope | undefined; sent: PageFilter[]; pageFilters?: PageFilter[] }) {
  const skipped = result?.provenance.skippedFilters ?? [];
  const skippedNames = [...new Set(skipped.map((s) => pageFilters?.find((c) => c.ref === s.ref)?.label ?? s.ref))];
  const applied = result ? sent.filter((c) => !skipped.some((s) => s.ref === c.ref)) : [];
  return (
    <>
      {applied.length > 0 && (
        <Tip content={applied.map(describePageFilter).join(" · ")}>
          <Badge tone="accent" className="min-w-0 shrink truncate">Filtered by {[...new Set(applied.map((c) => c.label))].join(", ")}</Badge>
        </Tip>
      )}
      {skipped.length > 0 && (
        <Tip content={[...new Set(skipped.map((s) => s.reason))].join(" ")}>
          <Badge className="min-w-0 shrink truncate">Not filtered by {skippedNames.join(", ")}</Badge>
        </Tip>
      )}
    </>
  );
}
